import styled from 'styled-components';

export const HeaderContainer = styled.div<{ isHistory: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 13px;

  ${({ isHistory }) =>
    isHistory &&
    `
      & > div:nth-child(2) > div:first-child {
        margin-right: 0;
      }
  `}
`;
